/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { useHistory, useParams } from 'react-router-dom';
import { ROUTES } from '../../constants/routes';
import { generateUrl } from '../../routes/util';
import { Menu } from '../menu/Menu';
import { NavCode } from '../survey-templates/types';

export const TemplateHistoryNav = () => {
  const history = useHistory();
  const { initiativeId, templateId, historyId, page } = useParams<{
    initiativeId: string;
    templateId: string;
    historyId: string;
    page: string;
  }>();
  const isCreating = !templateId;

  const getItem = (code: NavCode, label: string) => {
    const isActive = code === page;

    const onClick = () => {
      return history.push({
        pathname: generateUrl(ROUTES.SURVEY_TEMPLATES_HISTORY, { initiativeId, templateId, historyId, page: code }),
        search: history.location.search,
      });
    };

    return {
      active: isActive,
      disabled: isCreating,
      onClick,
      label
    }
  };

  return (
    <>
      <Menu className='mt-3' items={[
        getItem(NavCode.Configuration, 'Configuration'),
        getItem(NavCode.Scope, 'Template scope'),
        getItem(NavCode.Subsidiary, 'Subsidiaries'),
      ]} />
      <hr />
    </>
  );
};
